/**
 * Store Echange Sujets
 */
export default {
    state: {
        sujets: []
    },

    mutations: {
        /**
         * Initialise le state sujets
         */
        setSujets: function (state, sujets) {
            state.sujets = sujets
        }
    },

    getters: {
        optionsSujets: state => {
            return state.sujets
                .filter(sujet => sujet.parent_id === null || sujet.parent_id === sujet.id)
                .map(sujet => ({value: sujet.id, label: sujet.libelle})
            )
        },

        optionsAllSujets: state => {
            return state.sujets
                .map((sujet) => ({
                    value: sujet.id,
                    label: (sujet.parent_id ? state.sujets.find(parent => parent.id === sujet.parent_id).libelle + ' - ' : '') + sujet.libelle,
                }))
                .sort((a, b) => a.label > b.label ? 1 : -1)
        },

        optionsSousSujetsFromSujet: state => id => {
            return state.sujets
                .filter(sujet => sujet.parent_id === id)
                .map(sujet => ({value: sujet.id, label: sujet.libelle})
                )
        }
    }
}
